'use client';

import { useEffect, useState } from 'react';

export function ThemeToggle({ className = '' }: { className?: string; }) {
    const [theme, setTheme] = useState<'light' | 'dark'>('light');

    useEffect(() => {
        const root = document.documentElement;
        setTheme(root.classList.contains('dark') ? 'dark' : 'light');
    }, []);

    function toggle() {
        const next = theme === 'dark' ? 'light' : 'dark';
        const root = document.documentElement;
        root.classList.toggle('dark', next === 'dark');
        root.classList.toggle('light', next === 'light');
        root.style.colorScheme = next;
        localStorage.setItem('theme', next);
        document.cookie = `bt-theme=${next}; path=/; max-age=31536000; samesite=lax${location.protocol === 'https:' ? '; secure' : ''}`;
        setTheme(next);
    }

    return (
        <button type="button" onClick={toggle} aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`} title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`} className={`grid size-10 shrink-0 place-items-center rounded-full border border-border bg-surface/70 text-text-muted backdrop-blur-xl transition hover:bg-surface-hover hover:text-text-primary active:scale-95 ${className}`}>
            {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
        </button>
    );
}

function SunIcon() {
    return <svg viewBox="0 0 24 24" className="size-[18px] fill-none stroke-current" aria-hidden><circle cx="12" cy="12" r="3.5" strokeWidth="1.8"/><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42" strokeWidth="1.8" strokeLinecap="round"/></svg>;
}

function MoonIcon() {
    return <svg viewBox="0 0 24 24" className="size-[18px] fill-none stroke-current" aria-hidden><path d="M20 15.2A8 8 0 0 1 8.8 4 8.2 8.2 0 1 0 20 15.2Z" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>;
}
